(function ($) {
	$.homeVideoController = function (element, options) {
		// 1**************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			HomeVideoController = (function ($c, o) {
				var defaults = {
					video: '.video',
					title: '.title',
					timeout: 1500,
					fadeSpeed: 1.2,
					fadeOverlap: '-=1.1',
					frames: [
						{ text: 'Lake Life.' },
						{ text: 'Jump In.' },
						{ text: 'Escape.' },
						{ text: 'Explore.' },
						{ text: 'Bring Family.' },
						{ text: 'Grab a Friend.' },
						{ text: 'Set Sail.' }
					]
				}; 

				var _o = {},

					ci = 0, // Current Index
					tl = null, // Timeline
					v = null, // Vimeo Player

					$v = null, // Video
					$t = null // Title
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$v = $(_o.video, $c);
					$t = $(_o.title, $c);

					v = new Vimeo.Player($v.get(0));

					_InitVimeo();
					_InitTitle();
				},

				_InitVimeo = function() {
					v.ready().then(function() {
						v.setLoop(true).then(function() {
							v.setCurrentTime(0);
						});
					});
				},

				_InitTitle = function() {
					_SplitLetters(_o.frames[ci].text);
				},

				_OnInterval = function() {
					_BuildTimeline(0, function() {
						$t.css('opacity', 0);

						ci = (ci + 1) % _o.frames.length;
						_SplitLetters(_o.frames[ci].text);

						$('.letter', $t).css('opacity', 0);
						$t.css('opacity', 1);

						_BuildTimeline(1, function() {
							setTimeout(_OnInterval, _o.timeout);
						});
					});
				},

					_SplitLetters = function(text) {
						var letters = text.split('');

						// Build double span for each letter
						var $ds = $('<span />');
						letters.map(function(l) {
							var $ltr = $('<span />')
								.addClass('letter')
								.text(l)
								.appendTo($ds);
						});

						$t.empty().append($ds);
					},

					_BuildTimeline = function(op, cb) {
						if (tl) { tl.kill(); }
						tl = new TimelineLite({ onComplete: cb });

						$('.letter', $t).each(function(i) {
							var $l = $(this),
								l = $l.text;

							if (l != ' ') {
								tl.add(new TweenLite($l, _o.fadeSpeed, { css: { opacity: op } , ease: Power4.easeIn }), _o.fadeOverlap);
							}
						});
					},

				_BindEvents = function () {
					setTimeout(_OnInterval, _o.timeout * 4);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.homeVideoController = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('homeVideoController')) {
				var plugin = new $.homeVideoController(this, options);
				$(this).data('homeVideoController', plugin);
			}
		});
	};
})(jQuery);
